<template>
    <div class="w-100 file-upload-wrapper">
        <label :for="`fileUploader${idIndicator}`" :class="['file-upload-label', 'border-radius-10', 'extra-gray-color', 'px-3', 'py-2', {'cursor-pointer': (limit - choosenFilesArray.length) > 0}, 'w-100']">
            {{ `დაამატეთ ფაილები (${this.choosenFilesArray.length}/${this.limit})` }}
        </label>
        <input :ref="`fileUploader${idIndicator}`" :disabled="(limit - choosenFilesArray.length) <= 0" :multiple="true" type="file" @input.prevent="filesBeenAddedHandler" :accept="accept" :id="`fileUploader${idIndicator}`" class="d-none">
        <ul v-if="choosenFilesArray.length > 0 && (mode == 'photo' || mode =='video')" class="d-flex flex-wrap gap-2 px-3 py-2">
            <li v-for="(data, i) of choosenFilesArray" class="gap-1 image-wrapper" :title="data.fileObj.name">
                <img :src="data.url" alt="media" style="max-width: 70px; max-height: 70px; object-fit: contain;">
                <button @click.prevent="removeFile(i)" type="button" class="small-delete-btn">
                    <img src="@\assets\images\deleteButton.svg" alt="delete">
                </button>
            </li>
        </ul>
        <ul v-if="choosenFilesArray.length > 0 && (mode == 'audio')" class="d-flex flex-wrap gap-2 px-3 py-2">
            <li :title="data.fileObj.name" v-for="(data, i) of choosenFilesArray" class="gap-1 audio-label d-flex align-items-center justify-content-between">
                <p>
                    {{ data.fileObj.name }}
                </p>
                <button @click.prevent="removeFile(i)" type="button" class="small-delete-btn">
                    <img src="@\assets\images\deleteButton.svg" alt="delete">
                </button>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data(){
        return {
            choosenFilesArray: [],
        }
    },
    props: {
        mode: {
            type: String,
            default: "photo",
        },
        accept: {
            type: String,
            default: "image/jpeg",
        },
        multiple: {
            type: Boolean,
            default: true,
        },
        limit: {
            type: Number,
            default: 3,
        },
        idIndicator: {
            type: Number,
            default: 1,
        },
        filesEmptier: {
            type: Boolean,
            default: false,
        }
    },
    watch: {
        filesEmptier(){
            this.choosenFilesArray = [];
            this.$emit("filesBeenAdded", []);
        }
    },
    methods: {
        removeFile(index){
            this.choosenFilesArray.splice(index, 1);
            this.$emit("filesBeenAdded", this.choosenFilesArray.map((fileWideObj) => {return fileWideObj.fileObj}));
        },
        filesBeenAddedHandler(event){
            if(this.mode == "photo"){
                let tempURL;
    
                Object.values(this.$refs[`fileUploader${this.idIndicator}`].files).forEach((fileObj) => {
                    if(this.choosenFilesArray.length < this.limit && fileObj.type.startsWith("image/")){
                        tempURL = URL.createObjectURL(fileObj);
                        this.choosenFilesArray.push({
                            fileObj,
                            url: tempURL,
                        });
                    }
                });
                this.$emit("filesBeenAdded", this.choosenFilesArray.map((fileWideObj) => {return fileWideObj.fileObj}));
            }else if(this.mode == "audio"){
                Object.values(this.$refs[`fileUploader${this.idIndicator}`].files).forEach((fileObj) => {
                    if(this.choosenFilesArray.length < this.limit && fileObj.type.startsWith("audio/")){
                        
                        this.choosenFilesArray.push({
                            fileObj,
                        });
                    }
                });
                
                this.$emit("filesBeenAdded", this.choosenFilesArray.map((fileWideObj) => {return fileWideObj.fileObj}));
            }else if(this.mode == "video"){
                let videoURL;
                let photoURL;
                let canvasElement;
                let videoElement;
                let context;
    
                Object.values(this.$refs[`fileUploader${this.idIndicator}`].files).forEach((fileObj) => {
                    if (this.choosenFilesArray.length < this.limit && fileObj.type.startsWith("video/")) {
                        videoURL = URL.createObjectURL(fileObj);
                        videoElement = document.createElement("video");
                        videoElement.width = '720px';
                        videoElement.src = videoURL;
                        videoElement.muted = true;
                        videoElement.load();
                        videoElement.play();

                        videoElement.addEventListener('loadeddata', () => {

                            canvasElement = document.createElement("canvas");
                            canvasElement.width = videoElement.videoWidth;
                            canvasElement.height = videoElement.videoHeight;
                            context = canvasElement.getContext('2d');
                            
                            context.drawImage(videoElement, 0, 0, canvasElement.width, canvasElement.height);
                            
                            photoURL = canvasElement.toDataURL('image/png');

                            this.choosenFilesArray.push({
                                fileObj,
                                url: photoURL,
                            });
                            videoElement.pause();
                            videoElement.src = "";
                            URL.revokeObjectURL(videoURL);
                            
                            
                            this.$emit("filesBeenAdded", this.choosenFilesArray.map((fileWideObj) => {return fileWideObj.fileObj}));
                        });
                    }
                });
            }
            setTimeout(() => {
                this.$refs[`fileUploader${this.idIndicator}`].value = '';
            },0);
        },
    }
}
</script>
<style lang="scss" scoped>
.file-upload-wrapper{
    .file-upload-label{
        border: 1px solid var(--middle-gray);
    }
    .audio-label{
        position: relative;
        padding: 3px 5px;
        max-width: 120px;
        width: 100%;
        background-color: var(--extra-green);
        border-radius: 5px;
        color: var(--main-background-color);
        p{
            overflow: hidden;
            text-wrap: nowrap;
            text-overflow:ellipsis;
        }
    }
    .image-wrapper{
        position: relative;
    }
    .small-delete-btn{
        background-color: var(--main-background-color);
        height: 20px;
        position: absolute;
        border-radius: 50%;
        top: 0;
        right: 0;
        transform: translateX(30%) translateY(-30%);
        img{
            width: 20px;   
        }
    }
}
</style>